/**
 * Standard units of time used throughout Opal.
 */
export enum Timescale {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}

/**
 * @note If you’re working with `ISO8601Duration` you can convert `PlanTimescale` to its `TimeElement` with
 *
 * ```
 * ISO8601Duration.isValidTimeElement(timescale)
 *   ? timescale
 *   : null
 * ```
 */
export type PlanTimescale = 'day' | 'week' | 'month' | 'quarter'

export type StartMonthIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
